// ui/bountyMarkNotification.js
// Bounty mark rank-up notification popup

import { BOUNTY_MARKS } from '../skills/bounty/bountyData.js';

let notificationQueue = [];
let isShowingNotification = false;

/**
 * Check if a kill crossed a bounty mark rank threshold
 * @param {string} mobId - Mob identifier
 * @param {string} mobName - Mob display name
 * @param {number} prevKills - Kill count before this kill
 * @param {number} newKills - Kill count after this kill
 */
export function checkBountyMarkRankUp(mobId, mobName, prevKills, newKills) {
    const prevRank = getRankForKills(prevKills);
    const newRank = getRankForKills(newKills);

    if (newRank > prevRank) {
        const mark = BOUNTY_MARKS[newRank];
        queueNotification(mobName, mark);
    }
}

function getRankForKills(kills) {
    let rank = 0;
    for (let i = BOUNTY_MARKS.length - 1; i >= 0; i--) {
        if (kills >= BOUNTY_MARKS[i].kills) {
            rank = BOUNTY_MARKS[i].rank;
            break;
        }
    }
    return rank;
}

function queueNotification(mobName, mark) {
    notificationQueue.push({ mobName, mark });
    if (!isShowingNotification) {
        processNextNotification();
    }
}

function processNextNotification() {
    if (notificationQueue.length === 0) {
        isShowingNotification = false;
        return;
    }

    isShowingNotification = true;
    const { mobName, mark } = notificationQueue.shift();

    // Build bonus list
    const bonuses = [];
    if (mark.bountyBonus > 0) bonuses.push(`+${Math.round(mark.bountyBonus * 100)}% Bounty Rewards`);
    if (mark.dropRate > 0) bonuses.push(`+${mark.dropRate * 100}% Drop Rate`);
    if (mark.accuracy > 0) bonuses.push(`+${mark.accuracy} Accuracy`);
    if (mark.defIgnore > 0) bonuses.push(`+${mark.defIgnore} Def Ignore`);

    const bonusHtml = bonuses.map(b => `<span class="mark-bonus-item">${b}</span>`).join('');

    const notification = document.createElement('div');
    notification.className = 'bounty-mark-notification';
    notification.innerHTML = `
        <div class="mark-header">
            <span class="mark-label">Bounty Mark Earned!</span>
            <span class="mark-rank">Rank ${mark.rank}</span>
        </div>
        <div class="mark-details">
            <span class="mark-mob-name">${mobName}</span>
            <span class="mark-title">${mark.title}</span>
        </div>
        <div class="mark-bonuses">${bonusHtml}</div>
    `;

    document.body.appendChild(notification);

    requestAnimationFrame(() => {
        notification.classList.add('show');
    });

    setTimeout(() => {
        notification.classList.remove('show');
        notification.classList.add('hide');

        setTimeout(() => {
            notification.remove();
            processNextNotification();
        }, 300);
    }, 3000);
}

export default {
    checkBountyMarkRankUp
};
